/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ForecastTargetGroup,
  ForecastTargetGroupFromJSON,
  ForecastTargetGroupFromJSONTyped,
  ForecastTargetGroupToJSON,
} from "./";

/**
 *
 * @export
 * @interface ForecastConversionGroups
 */
export interface ForecastConversionGroups {
  /**
   *
   * @type {{ [key: string]: Array<ForecastTargetGroup>; }}
   * @memberof ForecastConversionGroups
   */
  conversionGroups: { [key: string]: Array<ForecastTargetGroup> };
}

export function ForecastConversionGroupsFromJSON(
  json: any,
): ForecastConversionGroups {
  return ForecastConversionGroupsFromJSONTyped(json, false);
}

export function ForecastConversionGroupsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ForecastConversionGroups {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    conversionGroups: json["conversionGroups"],
  };
}

export function ForecastConversionGroupsToJSON(
  value?: ForecastConversionGroups | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    conversionGroups: value.conversionGroups,
  };
}
